module.exports = __webpack_public_path__ + "static/media/contract-signed.3c3faf0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/contract-signed.svg
// module id = 1416
// module chunks = 0